"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RequestHandlerResolver = void 0;
var evm_api_1 = require("@moralisweb3/evm-api");
var common_evm_utils_1 = require("moralis/common-evm-utils");
var common_sol_utils_1 = require("moralis/common-sol-utils");
var api_utils_1 = require("@moralisweb3/api-utils");
var common_auth_utils_1 = require("@moralisweb3/common-auth-utils");
var auth_1 = require("@moralisweb3/auth");
var sol_api_1 = require("@moralisweb3/sol-api");
var moralis_1 = __importDefault(require("moralis"));
var modules = [
    {
        name: evm_api_1.EvmApi.moduleName,
        baseUrl: moralis_1.default.EvmApi.baseUrl,
        operations: common_evm_utils_1.operations,
    },
    {
        name: sol_api_1.SolApi.moduleName,
        baseUrl: moralis_1.default.SolApi.baseUrl,
        operations: common_sol_utils_1.operations,
    },
    {
        name: auth_1.Auth.moduleName,
        baseUrl: moralis_1.default.Auth.baseUrl,
        operations: common_auth_utils_1.operations,
    },
];
var RequestHandlerResolver = /** @class */ (function () {
    function RequestHandlerResolver() {
    }
    RequestHandlerResolver.tryResolve = function (moduleName, operationName) {
        var module = modules.find(function (mod) { return mod.name === moduleName; });
        if (!module) {
            return null;
        }
        var operation = module.operations.find(function (op) { return op.name === operationName; });
        if (!operation) {
            return null;
        }
        return new api_utils_1.OperationResolver(operation, module.baseUrl, moralis_1.default.Core);
    };
    return RequestHandlerResolver;
}());
exports.RequestHandlerResolver = RequestHandlerResolver;
//# sourceMappingURL=RequestHandlerResolver.js.map